import React, { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  Typography,
  Grid,
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { styled } from "@mui/system";
import { FaGraduationCap, FaHandHoldingUsd, FaWhatsapp } from "react-icons/fa";
import { TiGlobe } from "react-icons/ti";
import { GiFarmer } from "react-icons/gi";
import { AiFillProduct } from "react-icons/ai";
// import about from "../../public/assets/about.png"

const slides = [
  {
    src: "/assets/bg1.jpeg",
    // src: "https://cdn.pixabay.com/photo/2018/11/13/11/02/sunset-3812820_1280.jpg",
    // caption: "Caption Text",
  },
  {
    src: "https://cdn.pixabay.com/photo/2015/05/29/17/21/container-789488_1280.jpg",
    // caption: "Caption Two",
  },
  {
    src: "https://cdn.pixabay.com/photo/2021/09/27/11/01/man-6660387_1280.jpg",
    // caption: "Caption Three",
  },
];

const SlideshowContainer = styled(Box)({
  // width: "100vw",
  height: "100vh",
  "@media (max-width: 479px)": {
    height: "40vh",
  },
  position: "relative",
  overflow: "hidden",
});

const Slide = styled(Box)(({ active }) => ({
  display: active ? "block" : "none",
  width: "100%",
  height: "100%",
  position: "absolute",
  top: 0,
  left: 0,
}));

const Image = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
});

const Caption = styled(Typography)({
  position: "absolute",
  bottom: "20px",
  width: "100%",
  textAlign: "center",
  color: "#fff",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  padding: "15px",
  fontSize: "1.5rem",
});

const NavigationButton = styled(IconButton)({
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  color: "white",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.8)" },
});

const DotsContainer = styled(Box)({
  position: "absolute",
  bottom: "10px",
  width: "100%",
  textAlign: "center",
});

const Dot = styled(Box)(({ active }) => ({
  height: "12px",
  width: "12px",
  margin: "5px",
  display: "inline-block",
  borderRadius: "50%",
  backgroundColor: active ? "#717171" : "#bbb",
  transition: "background-color 0.6s ease",
  cursor: "pointer",
}));

const Container = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "20px",
  padding: "20px",
  flexWrap: "wrap",
});

const Imagee = styled("img")({
  maxWidth: "100%",
  height: "100%",
  borderRadius: "10px",
  width: "400px",
  height: "300px",
});

const TextContainer = styled(Box)({
  maxWidth: "550px",
  textAlign: "left",
  padding: "20px",
  height: "100%",
  //   height:"230px"
});

const FullScreenCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  // const prevSlide = () => {
  //   setCurrentIndex(
  //     (prevIndex) => (prevIndex - 1 + slides.length) % slides.length
  //   );
  // };

  // const setSlide = (index) => {
  //   setCurrentIndex(index);
  // };

  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* <Box
        sx={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          zIndex: 1000,
          backgroundColor: "#25D366", 
          padding: "15px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
          "&:hover": { backgroundColor: "#1EBEA5" },
        }}
      >
        <FaWhatsapp style={{ fontSize: "30px", color: "white" }} />
      </Box> */}

      <SlideshowContainer>
        {slides.map((slide, index) => (
          <Slide key={index} active={index === currentIndex}>
            <Image
              src={slide.src}
              alt={slide.caption}
              style={{
                width: "100%", 
                height: "85vh",
                objectFit: "cover", 
              }}
            />
            {/* <Caption>{slide.caption}</Caption> */}
          </Slide>
        ))}

        {/* <NavigationButton onClick={prevSlide} sx={{ left: 5 }}> */}
        {/* <ArrowBackIos /> */}
        {/* </NavigationButton> */}
        {/* <NavigationButton onClick={nextSlide} sx={{ right: 5 }}> */}
        {/* <ArrowForwardIos /> */}
        {/* </NavigationButton> */}
        {/* <DotsContainer>
          {slides.map((_, index) => (
            <Dot
              key={index}
              active={index === currentIndex}
              onClick={() => setSlide(index)}
            />
          ))}
        </DotsContainer> */}
      </SlideshowContainer>

      <Container>
        <Box>
          <Imagee src="/assets/about.png" alt="About Image" />
        </Box>
        <TextContainer>
          <Typography
            variant="h4"
            gutterBottom
            sx={{ fontSize: "25px", fontWeight: "700" }}
          >
            About Us
          </Typography>
          <Typography variant="body1">
            Established in the year 2017, West Valley Farm Organic ® is engaged
            in the sourcing & Marketing of farm Products and input supply to
            farmers. West Valley Organic Farm provides technology, consultancy
            and products that help the farmer through the entire life cycle
            right from farm input - plant care -harvesting - marketing
          </Typography>
          <Typography variant="body1">
            The Company was established by an agronomist by profession with more
            than 20 years of experience in agriculture and has a
            well-established presence in the techno-commercial fields in India.
          </Typography>
          <Typography variant="body1">
            We guarantee continual quality improvements and innovative
            solutions. Also, we assure you of our technical services and give a
            promising grower partnership for Indian Agro prosperity.
          </Typography>
        </TextContainer>
      </Container>

      <Container>
        <TextContainer>
          <Typography
            variant="h4"
            gutterBottom
            sx={{ fontSize: "25px", fontWeight: "700" }}
          >
            Vision
          </Typography>
          <Typography variant="body1">
            West Valley Organic Farm has the vision to be the leading supplier
            of superior-quality products in India. We are determined to be a
            reputed customer-driven organization by exceeding customer
            expectations.
          </Typography>
          <Typography variant="body1">
            Our aim lies in developing long-term supply agreements with
            strategic customers and developing new products. Also, we look
            forward to becoming the supplier of choice to the leading
            distributors in our industry.
          </Typography>
          <Typography variant="body1">
            To establish West Valley Organic Farm as the leading Food supplier
            in India To be a single point source for farm and organic produce
            for end users, by delivering quality
          </Typography>
        </TextContainer>
        <Box>
          <Imagee src="/assets/vision.jpg" alt="Placeholder" />
        </Box>
      </Container>

      <Box sx={{ padding: "40px 20px", backgroundColor: "#f5f5f5" }}>
        <Typography
          variant="h4"
          gutterBottom
          align="center"
          sx={{ fontSize: "25px", fontWeight: "700" }}
        >
          Interesting Facts
        </Typography>

        <Box
          sx={{
            backgroundColor: "#4A602F",
            borderRadius: 2,
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            padding: "15px 20px",
            margin: "20px auto",
            color: "white",
            gap: 2,
            width: "90%",
            // marginTop: "-17vh",
            "@media (max-width: 479px)": {
              flexDirection: "column",
              padding: "20px 10px",
              gap: 1.5,
              marginTop: "-1vh",
              height: "64vh",
            },
          }}
        >
          {/* First Info Item */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              textAlign: "left",
              gap: 2,
            }}
          >
            <GiFarmer style={{ fontSize: "40px" }} />
            <Box>
              <Typography
                variant="h4"
                sx={{ fontWeight: "bold", fontSize: "35px" }}
              >
                12000+
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontSize: "18px", marginTop: 1 }}
              >
                Farmers
              </Typography>
            </Box>
          </Box>

          {/* Divider */}
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              backgroundColor: "white",
              width: "2px",
              height: "100px",
              margin: "0 10px",
              "@media (max-width: 479px)": {
                width: "70%",
                height: "2px",
                margin: "10px 50px",
              },
            }}
          />

          {/* Second Info Item */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              textAlign: "left",
              gap: 2,
            }}
          >
            <AiFillProduct style={{ fontSize: "40px" }} />
            <Box>
              <Typography
                variant="h4"
                sx={{ fontWeight: "bold", fontSize: "35px" }}
              >
                15+
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontSize: "18px", marginTop: 1 }}
              >
                Products
              </Typography>
            </Box>
          </Box>

          {/* Divider */}
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              backgroundColor: "white",
              width: "2px",
              height: "100px",
              margin: "0 10px",
              "@media (max-width: 479px)": {
                width: "70%",
                height: "2px",
                margin: "10px 50px",
              },
            }}
          />

          {/* Third Info Item */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              textAlign: "left",
              gap: 2,
            }}
          >
            <img
              src="https://static.thenounproject.com/png/1248941-200.png"
              height={60}
              width={60}
              alt="ssd"
              style={{ background: "white" }}
            />
            <Box>
              <Typography
                variant="h4"
                sx={{ fontWeight: "bold", fontSize: "35px" }}
              >
                15000+
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontSize: "18px", marginTop: 1 }}
              >
                Acres Land Produce
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default FullScreenCarousel;
